import { useQuery } from '@tanstack/react-query';
import { getAdminHubInfo, getSystemStats, getAdminUsers, getPendingActions } from '../services/adminhub';

export const useAdminHubInfo = () => useQuery({ queryKey: ['adminhub', 'info'], queryFn: getAdminHubInfo });
export const useSystemStats = () => useQuery({ queryKey: ['adminhub', 'stats'], queryFn: getSystemStats });
export const useAdminUsers = () => useQuery({ queryKey: ['adminhub', 'users'], queryFn: getAdminUsers });
export const usePendingActions = () => useQuery({ queryKey: ['adminhub', 'pending'], queryFn: getPendingActions });
